import React from 'react';
import { at } from 'lodash';
import { useField } from 'formik';
import { Checkbox, FormControl,FormControlLabel } from "@mui/material";
import { useTranslation } from 'react-i18next';
import Link from '@mui/material/Link';
import { makeStyles } from "@material-ui/core/styles";

const checkBtn = makeStyles(() => ({
  root: {
    '& .MuiCheckbox-root':{
      paddingRight: "5px",
      paddingLeft:"0px",
      marginLeft: "10px",
      backgroundColor: "transparent",
    },
    '& .MuiSvgIcon-root':{
      width:"16px",
      height:"17px",
    }
  },
}));

export default function CsplCheckboxField(props) {
  const { label, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;
  const { t } = useTranslation("common");
  const classes = checkBtn();
  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return   <span className="cspl_error">{error}</span>;
 }
  }

  function _onChange(e) {
    setValue(e.target.checked);
  }

  return (
    <>
    <FormControl {...rest} sx={{
   '& .MuiFormControlLabel-root':{
    marginBottom:"-5px"
      }
    }}>
      <FormControlLabel
      
        value={field.value}
        checked={field.value}
        control={<Checkbox {...field} onChange={_onChange} />}
        className={classes.root}  
        label={
          <>
            {label && t(label)}
            {props.linktext &&  <Link
               className='checkBoxLinks'
              onClick={(e) => {                
                props.onlinkclick(e)
              }}
            >
              {t(props.linktext)}
            </Link>

            }
           
          </>
        }    
      />
      
      {_renderHelperText()}
    </FormControl>


    </>   
  );
}
